import { createOrUpdateBorrower } from '@/apiCalls/borrower';
import { DisplayButtons } from '@/components/DisplayButtons';
import { EUserFlow, selectSellerSelectedStoreId } from '@/context/borrower';
import {
    EDisplays,
    EJourneys,
    EModals,
    selectInitialJourney,
    selectPreviousDisplay,
    selectUserFlow,
    setDisplay,
    setModal,
} from '@/context/display';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { selectIsLoggedIn } from '@/context/user';

interface IProps {
    setShowErrors: (value: boolean) => void;
    baseId: string;
}

export function StoreSelectorButtons({
    setShowErrors,
    baseId,
}: IProps): JSX.Element {
    // ***** Redux State *****
    const dispatch = useAppDispatch();
    const previousDisplay = useAppSelector(selectPreviousDisplay);
    const isLoggedIn = useAppSelector(selectIsLoggedIn);
    const userFlow = useAppSelector(selectUserFlow);
    const isEarlySignup =
        userFlow === EUserFlow.EARLY_SIGNUP ||
        userFlow === EUserFlow.EARLY_SIGNUP.toLocaleUpperCase() ||
        userFlow === EUserFlow.INSTANT_LEAD_CAPTURE ||
        userFlow === EUserFlow.INSTANT_LEAD_CAPTURE.toLocaleUpperCase();
    const storeId = useAppSelector(selectSellerSelectedStoreId);
    const initialJourney = useAppSelector(selectInitialJourney);

    // ***** Event Handlers *****
    function handleBackClick(): void {
        if (previousDisplay === EDisplays.OCR_SUMMARY) {
            dispatch(setDisplay(EDisplays.OCR_SUMMARY));
            return;
        }
        createOrUpdateBorrower();
        dispatch(setDisplay(EDisplays.QUICK_CALCULATOR));
    }

    async function handleNextClick(): Promise<void> {
        setShowErrors(true);
        if (!isComplete()) return;
        setShowErrors(false);
        createOrUpdateBorrower();
        if (previousDisplay === EDisplays.OCR_SUMMARY) {
            if (initialJourney === EJourneys.TEST_DRIVE) {
                dispatch(setDisplay(EDisplays.TEST_DRIVE_AGREEMENT));
                createOrUpdateBorrower();
                return;
            } else {
                const nextScreen = EDisplays.PREPPROVAL_ANIMATION;
                dispatch(setDisplay(nextScreen));
                return;
            }
        }
        if (isEarlySignup && !isLoggedIn) {
            const nextModal = EModals.REGISTER;
            dispatch(setModal(nextModal));
            return;
        }
        const nextScreen = EDisplays.LOAN;
        dispatch(setDisplay(nextScreen));
    }

    // ***** Helpers *****
    function isComplete(): boolean {
        if (!storeId || storeId.length === 0) return false;
        return true;
    }

    return (
        <DisplayButtons
            idLeftButton={`${baseId}-button-back`}
            idRightButton={`${baseId}-button-next`}
            rightClick={handleNextClick}
            leftClick={handleBackClick}
        />
    );
}
